var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 30,
    viewBox: "0 0 41 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.9373 11.5797C34.3838 11.5797 36.4225 12.5175 38.0535 14.3932C39.6845 16.2688 40.5 18.3891 40.5 20.754C40.5 23.5267 39.5214 25.7693 37.5642 27.4818C35.607 29.1128 33.5275 29.9283 31.3257 29.9283C29.1239 29.9283 26.9628 28.9905 24.8425 27.1149C22.8038 25.1577 21.7844 22.6297 21.7844 19.5308C21.7844 14.7194 23.3338 10.5603 26.4327 7.05371C29.5316 3.46553 32.712 1.4268 35.974 0.9375L36.9526 2.89469C35.077 3.62863 32.9159 5.05575 30.4694 7.17603C28.1045 9.29632 26.8405 11.3758 26.6774 13.4146C28.7161 12.1913 30.4694 11.5797 31.9373 11.5797ZM10.6529 11.5797C13.0994 11.5797 15.1381 12.5175 16.7691 14.3932C18.4001 16.2688 19.2156 18.3891 19.2156 20.754C19.2156 23.5267 18.237 25.7693 16.2798 27.4818C14.3226 29.1128 12.2431 29.9283 10.0413 29.9283C7.921 29.9283 5.80071 28.9905 3.68043 27.1149C1.56014 25.1577 0.5 22.6297 0.5 19.5308C0.5 14.7194 2.04944 10.5603 5.14832 7.05371C8.2472 3.46553 11.4276 1.4268 14.6896 0.9375L15.6682 2.89469C13.7926 3.62863 11.6315 5.05575 9.18501 7.17603C6.82008 9.29632 5.55607 11.3758 5.39297 13.4146C7.4317 12.1913 9.18501 11.5797 10.6529 11.5797Z",
    fill: "#B08C3D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuote);
export default __webpack_public_path__ + "static/media/quote.c17cdb39f8a3f640ff5bad2cf1a8d2be.svg";
export { ForwardRef as ReactComponent };